module.exports = __webpack_public_path__ + "img/logo.59495b62.svg";